module.exports = __webpack_public_path__ + "static/media/php.a552af32.svg";